/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type consultAnExpert_item$ref = any;
export type consultAnExpert_item = {
    readonly isJewelry: boolean | null;
    readonly getCategoriesByLevel: ReadonlyArray<{
        readonly label: string | null;
    } | null> | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly convertedAmounts: {
                readonly USD: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": consultAnExpert_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "consultAnExpert_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isJewelry",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getCategoriesByLevel",
      "storageKey": "getCategoriesByLevel(level:2)",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 2
        }
      ],
      "concreteType": "Category",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "label",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totalAmount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "convertedAmounts",
              "storageKey": null,
              "args": null,
              "concreteType": "ConvertedAmounts",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "USD",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'ac35e69fe3303a472958609a00575961';
export default node;
